import * as React from 'react'

function SvgCateHome(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18.189 2.29c.388 0 .704.316.704.704v4.838l2.872 2.179a.414.414 0 01-.501.66L19.97 9.69v10.293a.93.93 0 01-.927.927H4.886a.93.93 0 01-.927-.927V9.69l-1.294.982a.415.415 0 01-.5-.661l9.8-7.437L15.9 5.561V2.994c0-.388.316-.704.704-.704zm-6.225 1.325L4.787 9.061v10.922c0 .053.047.098.1.098h4.609v-6.585h4.938v6.585h4.609a.101.101 0 00.098-.098V9.06l-7.177-5.446zm1.64 10.71h-3.28v5.756h3.28v-5.756zm-1.64-5.684a1.16 1.16 0 110 2.318 1.16 1.16 0 010-2.318zm6.1-5.522h-1.335v3.07l1.335 1.014V3.119z" />
    </svg>
  )
}

export default SvgCateHome
